import axios from "axios";
import { urlBase } from "./Constante/Url";
import { UserTockem } from "./Utils/autenticacao";

const getConfig = () => {
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem(UserTockem)}` },
  };
};

const getUser = (id) => {
  const url = `${urlBase}usuario/registro/${id}/`;
  const config = getConfig();
  const response = axios.get(url, config);
  return response;
};

const getAuthenticator = () => {
  const url = `${urlBase}usuario/otp/google-authenticator/`;
  const config = getConfig();
  const response = axios.get(url, config);

  return response;
};

export const userRequest = {
  getUser,
  getAuthenticator,
};
